import Dialog from '../generic/DialogAlkali'
import { Input, Button, Div, Label, Span } from 'alkali'
import { analysisSelections, analyzeTreatmentAs, structuredQuery, liveStructuredQuery } from 'model/SearchQuery'
import { studySearchCache, selectedTreatmentIds } from 'model/EvidenceSearch'

let inputValue
let window
class RenameDialog extends Dialog('.rename-dialog') {
	get defaults() {
		return {
			head: {
				titleText: 'Edit Name for Group / Arm',
				close: true,
			},
			foot: {},
			size: '350px',
		}
	}
	onShown() {
		this.querySelector('#new-group-input').focus()
	}
	ready(properties) {
		window = this
		this.body.append(
			Div([
				Div('.current-label', [ Span(['Current Name']), Span([`${properties.currentLabel}`])]),
				Label(['New Name ']),
				Input(
					'.input#new-group-input',
					{
						onchange(e) {
							inputValue = this.value
						},
						onkeypress(e) {
							if (e.key == 'Enter') {
								processName(this.value, properties.currentLabel)
								window.remove()
							}
						},
					},
					properties.currentLabel
				),
			])
		)
		this.footer.rightControls.append(
			Button('.primary', {
				textContent: 'Save',
				onclick(e) {
					processName(inputValue, properties.currentLabel)
					window.remove()
				},
			})
		)
	}
}
function processName(newName, currentLabel) {
	if (!newName) return
	let existingGroupIntervention = structuredQuery.interventions.valueOf().find(intervention => intervention.label == currentLabel)
	if (existingGroupIntervention) {
		existingGroupIntervention.label = newName
		if (existingGroupIntervention.fromText)
			existingGroupIntervention.fromText = false
	}
	for (let analyzeAs of analysisSelections.analyzeAs) {
		if (analyzeAs.label == currentLabel)
			analyzeAs.label = newName
	}
	let studySelections = analysisSelections.get('studySelections') || {}
	for (let id in studySelections) {
		let selections = studySelections[id]
		for (let groupAnalyzeAs of selections.groupAnalyzeAs || []) {
			if (groupAnalyzeAs?.analyzeLabel == currentLabel) groupAnalyzeAs.analyzeLabel = newName
		}
	}
	studySearchCache.clear()
	structuredQuery.interventions.put(structuredQuery.interventions.valueOf())
}

export default RenameDialog
